<!--
    Native News cell for the ADR 0014 grid (hosted renderer), ported from the ag-hosted NewsIcon
    wrapper. The app-wide news hover card activates on the `news-icon-hover` class through
    document-delegated listeners, so the icon works identically over the new grid.
-->
<script lang="ts">
    import { faNewspaper } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
    import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
    import type { GridHostedCellProps } from '@thinkalpha/ui-table-svelte/svelteCellHost.svelte';

    interface Props extends GridHostedCellProps {
        /** Static per-column props: optional to satisfy the host contract, always provided. */
        symbolFieldId?: string;
        changeCloseFieldId?: string;
    }

    let { cell, symbolFieldId, changeCloseFieldId }: Props = $props();

    const ticker = $derived.by(() => {
        const value = symbolFieldId === undefined ? undefined : cell.row[symbolFieldId];
        return typeof value === 'string' ? value : undefined;
    });
    const changeDirection = $derived.by(() => {
        const changeClose = changeCloseFieldId === undefined ? undefined : cell.row[changeCloseFieldId];
        if (typeof changeClose !== 'number') return 0;
        return changeClose > 0 ? 1 : changeClose < 0 ? -1 : 0;
    });
</script>

<div class="flex w-full justify-center">
    <span class="news-icon-hover" data-ticker={ticker} data-change-direction={changeDirection}>
        <FontAwesomeIcon icon={faNewspaper} class="text-steel-500" />
    </span>
</div>
